// @flow
import * as React from 'react';
import l from 'app/Translate';
import cx from 'classname';
import { Button } from '@phg/stilo-toolbox/v2/component';

import type {ButtonDerivedProps} from 'app/hoc/createButton';

type SubmitButtonProps = ButtonDerivedProps & {
    classes: {}
};

const errorStyle = {
    display: 'block',
    flex: '0 1 100%',
    paddingTop: 10,
    fontSize: 12,
    color: '#FD7280',
    textAlign: 'right',
    fontFamily: ['Roboto', 'sans-serif'],
    fontStyle: 'italic'
};

// eslint-disable-next-line no-unused-vars
const SubmitButton = ({ submitFailed, hasErrors, loading, classes = {}, handleSubmit }: SubmitButtonProps) => (
    <React.Fragment>
        <Button.Main
            id='continueBtn'
            type="submit"
            className={cx((hasErrors || loading) && 'disabled')}
            onClick={handleSubmit}
            disabled={hasErrors || loading}
        >
            {l('Sign up')}
        </Button.Main>
        {submitFailed && (
            <div style={errorStyle}>
                {l('Signup was unsuccessful. Try again')}
            </div>
        )}
    </React.Fragment>
);

export default SubmitButton;
